export enum SubscriptionStatusEnum {
  Requested = 'Requested',
  Denied = 'Denied',
  Approved = 'Approved',
  Active = 'Active',
  Cancelling = 'Cancelling',
  Cancelled = 'Cancelled',
  Suspended = 'Suspended',
}


// WEBPACK FOOTER //
// ./src/modules/shared/models/SubscriptionStatusEnum.ts